export function checkHttpStatus(response) {
  if (response.status >= 400) {
    throw Object.assign({}, {
      message: response.statusText,
      response: {
        status: response.status,
        statusText: response.statusText,
        url: response.url
      }
    });
  } else {
    return response;
  }
}

export const getDevices = () => {
  const groupNode = document.getElementById('groupid');
  if (!groupNode) return Promise.reject();

  const groupid = groupNode.getAttribute('data-attr') || 'None';
  return fetch(`/getdirectory?groupid=${groupid}`, { method: 'GET', credentials: 'same-origin' })
    .then(checkHttpStatus)
    .then(response => response.text())
    .then((response) => {
      const parsedJSON = JSON.parse(response);
      return Promise.resolve(parsedJSON);
    })
    .catch(err => (Promise.reject(err)));
};

export const deleteDevice = serial => (
  fetch(`/delete?serial=${serial}`, { method: 'GET', credentials: 'same-origin' })
    .then(checkHttpStatus)
    .then(response => response.text())
    .then((response) => {
      const parsedJSON = JSON.parse(response);
      if (parsedJSON.deleted) {
        return Promise.resolve(parsedJSON);
      }

      return Promise.reject(parsedJSON);
    })
    .catch(err => (Promise.reject(err)))
);

export const modifyDevice = (config = {}) => (
  fetch('/modify', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(config)
  })
    .then(checkHttpStatus)
    .then(response => response.text())
    .then((response) => {
      const parsedJSON = JSON.parse(response);
      if (parsedJSON.modified) {
        return Promise.resolve(parsedJSON);
      }
      return Promise.reject(parsedJSON);
    })
    .catch(err => (Promise.reject(err)))
);

export const createDevice = (config = {}) => (
  fetch('/create', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(config)
  })
    .then(checkHttpStatus)
    .then(response => response.text())
    .then((response) => {
      const parsedJSON = JSON.parse(response);
      if (parsedJSON.modified) {
        return Promise.resolve(parsedJSON);
      }
      return Promise.reject(parsedJSON);
    })
    .catch(err => (Promise.reject(err)))
);

export default {
  getDevices,
  deleteDevice,
  modifyDevice
}


// WEBPACK FOOTER //
// ./src/utils/deviceUtils.js